import React from 'react';
import { func_cookieSetting, func_datetime, func_validation, isNumberValid, isStringTrimNotEmpty } from 'functions';

export function useMainReportColumns(currentTabId) {

    function getColumn_salesPersonCode() {
        let columnClassName = "columns__sales-person-code flex-fill";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Sales Person Code",
            id: "salesPersonCode",
            accessor: "AgentCode",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = value? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumn_salesPersonName() {
        let columnClassName = "columns__sales-person-name flex-fill";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Sales Person Name",
            id: "salesPersonName",
            accessor: "AgentName",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = value? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumn_year() {
        let columnClassName = "columns__year";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Year",
            id: "year",
            accessor: "Year",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isNumberValid(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 150
        }
    }

    function getColumn_month() {
        let columnClassName = "columns__month";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Month",
            id: "month",
            accessor: "Month",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = value? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 150
        }
    }

    function getColumn_oneMonthCommission() {
        let columnClassName = "columns__one-month-commission";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "One Month Commission (RM)",
            id: "oneMonthCommission",
            accessor: "Total_Commission",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isNumberValid(value)? value: "-";

                if (value_formatted != "-")
                    value_formatted = func_cookieSetting.getFormattedPrice(value_formatted, { currencyDisabled: true });
    
                return (
                    <div className={"noWrap-text-ellipsis "}>{value_formatted}</div>
                );
            },
            width: 300
        }
    }

    function getColumn_totalSales() {
        let columnClassName = "columns__total-sales";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Total Sales (RM)",
            id: "totalSales",
            accessor: "Total_Sales",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isNumberValid(value)? value: "-";

                if (value_formatted != "-")
                    value_formatted = func_cookieSetting.getFormattedPrice(value_formatted, { currencyDisabled: true });
    
                return (
                    <div className={"noWrap-text-ellipsis "}>{value_formatted}</div>
                );
            },
            width: 175
        }
    }
    
    function getColumn_totalCommission() {
        let columnClassName = "columns__total-commission";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Total Commission (RM)",
            id: "totalCommission",
            accessor: "Total_Commission",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isNumberValid(value)? value: "-";

                if (value_formatted != "-")
                    value_formatted = func_cookieSetting.getFormattedPrice(value_formatted, { currencyDisabled: true });
    
                return (
                    <div className={"noWrap-text-ellipsis "}>{value_formatted}</div>
                );
            },
            width: 175
        }
    }

    let columns = [];
    if (currentTabId === "newOutlet") {
        columns = [
            getColumn_salesPersonCode(),
            getColumn_salesPersonName(),
            getColumn_year(),
            getColumn_month(),
            getColumn_oneMonthCommission(),
        ]
    }
    else {
        columns = [
            getColumn_salesPersonCode(),
            getColumn_salesPersonName(),
            getColumn_year(),
            getColumn_month(),
            getColumn_totalSales(),
            getColumn_totalCommission()
        ];
    }

    return {
        columns
    }
}